import React from "react";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import { BsFileEarmarkPerson } from "react-icons/bs";

import styled from "@emotion/styled";

const Social = styled.div`
  display: block;
  position: fixed;
  top: 48%;
  left: 1.5rem;
  transform: translateY(-50%);

  ul {
    display: block;
  }

  .item + .item {
    margin-top: 1rem;
  }

  a {
    font-size: 2rem;
    color: rgb(119, 119, 121);
    transition: 0.2s ease-in;
    &:hover {
      color: rgb(198, 153, 252);
    }
  }

  @media screen and (max-width: 768px) {
    display: none;
  }
`;
function FixSocialIcon() {
  return (
    <Social>
      <ul>
        <li className="item">
          <a
            href="https://www.linkedin.com/in/pedro-sales-muniz"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin />
          </a>
        </li>
        <li className="item">
          <a
            href="https://github.com/salesp07"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithub />
          </a>
        </li>
        <li className="item">
          <a
            href="https://github.com/salesp07"
            target="_blank"
            rel="noopener noreferrer"
          >
            <BsFileEarmarkPerson />
          </a>
        </li>
        {/* <li className="item">
          <a
            href="https://discord.gg/ehdRp2PfFv"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaDiscord />
          </a>
        </li> */}
      </ul>
    </Social>
  );
}

export default FixSocialIcon;
